import { render, staticRenderFns } from "./viewInvoiceConfirm.vue?vue&type=template&id=960f63f2&scoped=true&"
import script from "./viewInvoiceConfirm.vue?vue&type=script&lang=js&"
export * from "./viewInvoiceConfirm.vue?vue&type=script&lang=js&"
import style0 from "./viewInvoiceConfirm.vue?vue&type=style&index=0&id=960f63f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960f63f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('960f63f2')) {
      api.createRecord('960f63f2', component.options)
    } else {
      api.reload('960f63f2', component.options)
    }
    module.hot.accept("./viewInvoiceConfirm.vue?vue&type=template&id=960f63f2&scoped=true&", function () {
      api.rerender('960f63f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/viewInvoiceConfirm.vue"
export default component.exports